/* @flow */

import type { GamestreamToken } from '../../../../helpers/gaming/types';
import type { NETGEM_API_V8_FEED_ITEM } from '../../../../libs/netgemLibrary/v8/types/FeedItem';
import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { createCustomNetworkErrorFromKey } from '../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { REDUX_MSG_REQUEST_GENERIC } from '../../constants';
import { generateApiUrl } from '../helpers/api';

const sendV8GetGamestreamTokenRequest: (item: NETGEM_API_V8_FEED_ITEM, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (item, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<GamestreamToken> => {
    const state = getState();
    const {
      netgemApi: { getGamestreamTokenUrl },
    } = state;

    if (!getGamestreamTokenUrl) {
      return Promise.reject(createCustomNetworkErrorFromKey('common.messages.errors.missing_url_definition', { urlDef: 'getGamestreamTokenUrl' }));
    }

    const { authent, method } = getGamestreamTokenUrl;

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_GENERIC, {
      authent,
      method,
      signal,
      uri: generateApiUrl(getGamestreamTokenUrl, { item }, state),
    }).then(({ result }) => result as GamestreamToken);
  };

export default sendV8GetGamestreamTokenRequest;
